import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Section, Toggle } from '../settingsPrimitives';
import { useTerminalConfigStore } from '../../store/terminalConfigStore';
import { useTerminalShells } from './useTerminalShells';

/**
 * Settings → Extensions → Terminal → "Shells": hide detected shells you never
 * use (owner, 30.09.2026). A hidden shell leaves every shell picker — the "+"
 * / New terminal menu, "Split with…" — but keeps working where it is open,
 * and agent profiles that name it keep launching it. The last visible shell
 * cannot be hidden. A newly installed shell shows up visible; a hidden one
 * that gets uninstalled just drops out of this list.
 */
export default function TerminalShellVisibilitySetting() {
  const { t } = useTranslation();
  const shells = useTerminalShells();
  const hidden = useTerminalConfigStore((s) => s.prefs?.hiddenShells) || [];
  const setShellHidden = useTerminalConfigStore((s) => s.setShellHidden);
  const visibleCount = shells.filter((s) => !hidden.includes(s.key)).length;

  if (shells.length === 0) return null;
  return (
    <Section title={t('terminalExt.shellsSection', 'Shells')}>
      {shells.map((shell) => {
        const isHidden = hidden.includes(shell.key);
        const last = !isHidden && visibleCount <= 1;
        return (
          <Row
            key={shell.key}
            label={shell.label}
            desc={last ? t('terminalExt.shellLastVisible', 'At least one shell stays in the menus.') : shell.path}
          >
            <Toggle value={!isHidden} disabled={last} onChange={(show) => setShellHidden(shell.key, !show)} />
          </Row>
        );
      })}
    </Section>
  );
}
